import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  outline: 0;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useContext } from 'react';
import styled from 'styled-components';
import { TabsContext } from './context';
import { getTabButtonID, getTabPanelID } from './helpers';
import { baseHighlightStyle } from '../tokens/highlight';
var TabPanelWrapper = styled.div(_templateObject(), function (_ref) {
  var hidden = _ref.hidden;
  return hidden ? "display: none;" : '';
}, baseHighlightStyle);
var TabPanel = /*#__PURE__*/React.forwardRef(function (_ref2, forwardedRef) {
  var name = _ref2.name,
      children = _ref2.children,
      _ref2$destroyOnHide = _ref2.destroyOnHide,
      destroyOnHide = _ref2$destroyOnHide === void 0 ? false : _ref2$destroyOnHide,
      _ref2$autoHide = _ref2.autoHide,
      autoHide = _ref2$autoHide === void 0 ? true : _ref2$autoHide,
      props = _objectWithoutPropertiesLoose(_ref2, ["name", "children", "destroyOnHide", "autoHide"]);

  var _useContext = useContext(TabsContext),
      selected = _useContext.selected;

  return destroyOnHide && selected !== name ? null : /*#__PURE__*/React.createElement(TabPanelWrapper, _extends({
    ref: forwardedRef
  }, autoHide ? {
    tabIndex: 0
  } : {}, {
    role: "tabpanel",
    id: getTabPanelID(name),
    "aria-labelledby": getTabButtonID(name)
  }, autoHide && selected !== name ? {
    hidden: true
  } : {}, props), children);
});
export default TabPanel;